export default __webpack_public_path__ + "static/media/warranty.0fdb780f.svg";